import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

const AddItemSch = ({ show, onClose, onCreated, refresh ,onSuccess }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [name, setName] = useState('');
  const [service_sttm, setServiceSTTMValue] = useState(null);
  const [service_edtm, setServiceEdTMValue] = useState(null);
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState('');
  const [nameLengthError, setNameLengthError] = useState('');
  const [descLengthError, setDescLengthError] = useState('');

  const handleNameChange = (e) => {
    let value = e.target.value;
    value = value.charAt(0).toUpperCase() + value.slice(1);
    setName(value);
    setErrors(prev => ({ ...prev, itemschedule_name: '' }));
    setGeneralError('');
    if (value.length <= 300) {
      setNameLengthError('');
    }
  };

  const handleDescriptionChange = (e) => {
    let value = e.target.value;
    value = value.charAt(0).toUpperCase() + value.slice(1);
    setDescription(value);
    if (value.length > 500) {
      setDescLengthError('Limit reached (max 500 characters)');
    } else {
      setDescLengthError('');
    }
  };

  const handleSubmit = () => {
    const validationErrors = {};

    setErrors({});
    setGeneralError('');
    setNameLengthError('');
    setDescLengthError('');

    if (!name.trim()) {
      validationErrors.itemschedule_name = "This field is required";
    } else if (name.length > 300) {
      setNameLengthError('Limit reached (max 300 characters)');
      return;
    }

    if (!service_sttm) {
      validationErrors.production_start_time = "This field is required";
    }

    if (!service_edtm) {
      validationErrors.production_end_time = "This field is required";
    }

    if (description.length > 500) {
      setDescLengthError('Limit reached (max 500 characters)');
      return;
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    axios.post(`${baseURL}/item-schedule`, {
      itemschedule_name: name,
      production_start_time: service_sttm.format("hh:mm A"),
      production_end_time: service_edtm.format("hh:mm A"),
      description: description,
    })
    .then(() => { 
      onClose();
      if (onCreated) onCreated();
      onSuccess();
    //   window.location.reload();
    })
    .catch(error => {
      const res = error.response;
      console.log("Error response:", res?.data);

      if (res?.data?.message) {
        setGeneralError(res.data.message);
      }

      if (res?.data?.errors) {
        setErrors(res.data.errors);
      }
    });
  };

  return (
    <Modal show={show} onHide={onClose} size="md">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Item Schedule</h3>
          <Button variant="" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Item Schedule <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Item Schedule"
                value={name}
                onChange={handleNameChange}
              />
              {errors.itemschedule_name && (
                <div className="text-danger mt-1">{errors.itemschedule_name}</div>
              )}
              {nameLengthError && (
                <span className="text-danger mt-1">{nameLengthError}</span>
              )}
              {generalError && (
                <span className="text-danger mt-1">{generalError}</span>
              )}
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Production Start Time <span className="required">*</span>
              </label>
              <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                <div className="input-group-text bg-transparent border-0 px-0">
                  <i className="fa-solid fa-clock fs-4"></i>
                </div>
                <DatePicker
                  placeholder="Select Time"
                  disableDayPicker
                  value={service_sttm}
                  onChange={setServiceSTTMValue}
                //   format="hh : mm A"
                  format="HH:mm"     
                  plugins={[<TimePicker />]}
                  className={errors.production_start_time ? 'border border-danger' : ''}
                />
              </div>
              {errors.production_start_time && (
                <div className="text-danger mt-1">{errors.production_start_time}</div>
              )}
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Production End Time <span className="required">*</span>
              </label>
              <div className="datepicker-wrapper d-flex border-bottom border-gray-300">
                <div className="input-group-text bg-transparent border-0 px-0">
                  <i className="fa-solid fa-clock fs-4"></i>
                </div>
                <DatePicker
                  placeholder="Select Time"
                  disableDayPicker
                  value={service_edtm}
                  onChange={setServiceEdTMValue}
                //   format="hh : mm A"
                format="HH:mm"     
                  plugins={[<TimePicker />]}
                  className={errors.production_end_time ? 'border border-danger' : ''}
                />
              </div>
              {errors.production_end_time && (
                <div className="text-danger mt-1">{errors.production_end_time}</div>
              )}
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={4}
                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                placeholder="Description"
                value={description}
                onChange={handleDescriptionChange}
              />
              {descLengthError && (
                <span className="text-danger mt-1">{descLengthError}</span>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
            <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
            <Button variant="primary" size="sm" onClick={handleSubmit}>Create Item Schedule</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddItemSch;
